module.exports = __webpack_public_path__ + "img/mind_map.b40a6c65.svg";